<template>
  <div class="equipment common_bg">
    <Back @goBack="goback"/>
    <h2>设备检测</h2>
    <section class="default" v-show="checkStatus===0">
      <ul>
        <li></li>
      </ul>
      <p>为了保障上课质量，花一分钟检测一下您的设备</p>
      <button class="cursor" @click="startTest">开始检测</button>
    </section>
    <section class="check" v-show="checkStatus!==0">
      <ul>
        <!-- 检测通过 check_success 正在检测voice-active 线变色line-active 检测未通过check_error-->
        <li :class="['notwork',checkStatus>3?networkStatus===1?'check_success':'check_error':'']">网络检测</li>
        <li class="line" :class="{'line-active':checkStatus!==1}"></li>
        <li :class="['voice',checkStatus>3?voiceStatus===1?'check_success':'check_error':'',{'voice-active':checkStatus>=2}]">扬声器检测</li>
        <li class="line" :class="{'line-active':checkStatus!==1 && checkStatus!==2}"></li>
        <li :class="['microphone',checkStatus>3?microphoneStatus===1?'check_success':'check_error':'',{'microphone-active':checkStatus>=3}]">麦克风检测</li>
      </ul>
      <div class="content network_content" v-show="checkStatus===1">
        <div class="progress">
          <svg width="110" height="110" viewBox="0 0 110 110" style="transform: rotate(-90deg);">
            <!-- 圆形进度条 -->
            <circle
              id="precentCircle"
              cx="55"
              cy="55"
              r="50"
              fill="none"
              stroke="#F5B227"
              stroke-width="10"
              :stroke-dasharray="strokeDasharray"
              stroke-linecap="round"
            ></circle>
          </svg>
          <span>{{progress}}%</span>
        </div>
        <p>网络检测中，请勿退出</p>
      </div>
      <div class="content voice_content" v-show="checkStatus===2">
        <video ref="video" class="video" src="/static/video/videoTest.mp4" loop></video>
        <p>是否能够清晰的听到声音？<br />（不要设置静音哦）</p>
        <div class="btn_box">
          <button class="cursor" @click="checkVoice(2)">不能</button>
          <button class="cursor" @click="checkVoice(1)">能</button>
        </div>
      </div>
      <div class="content microphone_content" v-show="checkStatus===3">
        <div class="microphone_box">
          <img src="../../../assets/img/equipment/microphone1.png" alt="">
          <div class="vertical_line_box">
            <span class="vertical_line" :class="{'vertical_line_active':db>item}" v-for="(item, index) in 8" :key="index" :style="{height:index*9+15+'px'}"></span>
          </div>
        </div>
        <p>请对着麦克风说 “我正在狸米新启航学习” 能否看到音量的波形变化？<br />（音量有波形变化，即为麦克风功能正常）</p>
        <!-- <p>请对着麦克风说“我正在狸米新启航学习”<br />能否清晰的看到音量的变化？</p> -->
        <div class="btn_box">
          <button class="cursor" :class="{'btn_disabled':checkMicrophoneStatus===0}" @click="checkMicrophone(2)">不能</button>
          <button class="cursor" :class="{'btn_disabled':checkMicrophoneStatus===0}" @click="checkMicrophone(1)">能</button>
        </div>
      </div>
      <div class="content success_content" v-show="checkStatus===4">
        <div class="success_icon">检测通过</div>
      </div>
      <div class="content error_content" v-show="checkStatus===5">
        <div class="check_result_hint">
          <h3>问题排查小贴士</h3>
          <p v-if="networkStatus===2">网 络：{{networkHint}}</p>
          <p v-if="voiceStatus===2">扬声器：请检查是否静音、音量大小、确认没有耳机等外接设备</p>
          <p v-if="microphoneStatus===2">麦克风：{{microphoneHint}}</p>
        </div>
        <div class="btn_box">
          <button class="cursor" @click="goAdvice">求助技术支持</button>
          <button class="cursor" @click="checkAgain">重新检测</button>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Back from "@/components/basic/back.vue";
import axios from "@/js/axios";
import { mapState,mapMutations } from "vuex";
import {IFly} from "limi-lib/dist/lib/limi/audio/IFly";
if (LIMI_ENV === "electron") {
  var ping = require("node-http-ping");
}
export default {
  name: "equipment",
  data() {
    return {
      strokeDasharray: "0 10000", //圆形进度条
      progress: 0, //检测进度百分比
      checkStatus: 0, //检测当前状态 0 未开始 1网络 2声音 3麦克风 4成功 5失败
      networkStatus: 0, //网络 0初始值 1成功 2 失败
      voiceStatus: 0, //扬声器 0初始值 1成功 2 失败
      microphoneStatus:0,//麦克风 0初始值 1成功 2 失败
      microphoneHint:"",
      networkHint: "", //网络检测失败提示
      perimeter: 50 * 2 * Math.PI, //周长
      resultsArr: [],
      logData: [], //成功数据结果
      checkInterval: null,
      checkProgress: 0, //检测次数
      pcH5PingArr: [], //一个接口ping4次数据保存
      checkMicrophoneStatus:0,//麦克风权限当前状态 0初始值
      db:0,//分贝
      ifly:null,
    };
  },
  components: {
    Back
  },
  computed: {
    ...mapState(["domain_list_for_ping"])
  },
  created() {},
  methods: {
    ...mapMutations([ "refreshNet"]),
    startTest() {
      if (!navigator.onLine) {
        this.refreshNet(false);
        return;
      }
      //开始检测
      let arr = LIMI_ENV === "web" ? this.domain_list_for_ping.api : [...this.domain_list_for_ping.api, ...this.domain_list_for_ping.live ];
      let timeout = LIMI_ENV === "web" ? 100 : Math.floor((4 * 650 * arr.length) / 100);
      this.checkInterval = setInterval(() => {
        if (this.progress >= 100) {
          clearInterval(this.checkInterval);
          if (this.checkProgress === arr.length && this.resultsArr.length === 0 ) {
            this.networkStatus = 1;
          } else {
            this.networkStatus = 2;
            let index1 = this.resultsArr.findIndex(item => {
              return item.type === 1;
            });
            let index2 = this.resultsArr.findIndex(item => {
              return item.type === 2;
            });
            let str = index1 !== -1 ? "API" : "";
            str += index2 !== -1 ? (str ? "、流媒体" : "流媒体") : "";
            this.networkHint = str + "请求失败，请检查WIFI信号是否正常，网络设置是否正常";
          }
          this.checkStatus = 2;
          this.$refs.video.play();
          return;
        }
        this.progress++;
        this.strokeDasharray = `${(this.perimeter * this.progress) / 100}  ${this.perimeter}`;
      }, timeout);
      if (LIMI_ENV === "web") {
        arr.forEach(url => {
          this.webPing(url);
        });
      } else {
        this.pcH5Ping(arr);
      }
      this.checkStatus = 1;
    },
    pcH5Ping(arr) {
      let url = arr[this.checkProgress];
      if (!url) return;
      ping("https://" + url)
        .then(time => {
          this.pcH5PingArr.push(time);
          if (this.pcH5PingArr.length === 4) {
            let totalTime = 0;
            this.pcH5PingArr.forEach(t => {
              totalTime += t;
            });
            totalTime = totalTime / 4;
            let data = {
              url: url,
              time: totalTime,
              type: arr[arr.length - 1] === url ? 2 : 1, //数组最后一位是流媒体
              success: !(totalTime === 0 || totalTime >= 150)
            };
            !data.success && this.resultsArr.push(data);
            this.pcH5PingArr = [];
            this.checkProgress++;
            this.logData[url] = totalTime;
          }
          this.pcH5Ping(arr);
        })
        .catch(() => {
          this.resultsArr.push({
            url: url,
            time: 0,
            type: arr[arr.length - 1] === url ? 2 : 1, //数组最后一位是流媒体
            success: false
          });
        });
    },
    webPing(item) {
      let url = "https://" + item + "/favicon.ico?" + Date.now();
      let img = new Image();
      let start = new Date();
      img.onload = () => {
        clearTimeout(timer);
        this.webPingCheck(item, start, true);
      };
      img.onerror = e => {
        clearTimeout(timer);
        this.webPingCheck(item, start, false);
      };
      let timer = setTimeout(() => {
        this.webPingCheck(item, start, false);
      }, 2000);
      img.src = url; // Trigger image load with cache buster
    },
    webPingCheck(item, start, wasSuccess) {
      if (JSON.stringify(this.resultsArr).includes(item)) return;
      this.checkProgress++;
      let pong = new Date() - start;
      let data = {
        url: item,
        time: pong,
        type: 1,
        success: wasSuccess
      };

      !wasSuccess && this.resultsArr.push(data);
      if (wasSuccess) {
        this.logData[item] = "success";
      } else {
        this.logData[item] = "fail";
      }
    },
    startRecord(){
      if(!this.ifly){
        this.ifly=new IFly();
        this.ifly.addListener(IFly.WAVE, (e) => {
          this.db = e/30*8;
        });
      }
      this.ifly.start(false);
    },
    checkPermissions(){
      this.$root.eventHub.$emit("checkMicrophonePermission");
      this.$root.eventHub.$off("checkMicrophonePermissionSuccess");
      this.$root.eventHub.$off("checkMicrophonePermissionError");
      this.$root.eventHub.$on("checkMicrophonePermissionSuccess",()=>{
        this.checkMicrophoneStatus = 1;
        this.startRecord();
      });
      this.$root.eventHub.$on("checkMicrophonePermissionError",(code)=>{
        if(code==8){
          this.microphoneHint = '无麦克风设备，课中无法使用语音答题';
        }else{
          if(LIMI_ENV==="electron"){
            this.microphoneHint='当前麦克风为禁止状态，请前往系统设置中开启麦克风权限';
          }else{
            this.microphoneHint='当前麦克风为禁止状态，请前往浏览器或系统设置中开启麦克风权限';
          };
        }
        this.microphoneStatus  = 2;
        this.checkResult();
      });
    },
    checkVoice(status) {
      this.$refs.video.pause();
      this.$refs.video.currentTime = 0;
      this.voiceStatus = status;
      this.checkStatus = 3;
      this.checkPermissions();
    },
    checkMicrophone(status){
      this.ifly.stop(false);
      this.microphoneStatus  = status;
      this.microphoneHint = "请检查麦克风是否遮挡，确认选择正确插口";
      this.checkResult();
    },
    checkResult(){
       if (this.voiceStatus === 2 || this.networkStatus === 2 || this.microphoneStatus===2) {
        this.checkStatus = 5;
      } else {
        this.checkStatus = 4;
      }
      let logData = {};
      let errType = [];
      if (this.networkStatus === 2) {
        errType.push(1);
      }
      if (this.voiceStatus === 2) {
         errType.push(2);
      }
      if (this.microphoneStatus === 2) {
        errType.push(3);
      }
      if (this.checkStatus === 4) {
        logData.type = 1;
        logData.errorType = "";
        logData.hosts = [];
      } else {
        logData.type = 2;
        logData.errorType = errType.join();
        logData.hosts = this.logData;
      }
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventEqumentResult",
        data: logData
      });
    },
    checkAgain() {
      this.strokeDasharray = "0 10000";
      this.progress = 0;
      this.checkStatus = 0;
      this.networkStatus = 0;
      this.voiceStatus = 0;
      this.microphoneStatus = 0;
      this.networkHint = "";
      this.resultsArr = [];
      this.checkProgress = 0;
      this.pcH5PingArr = [];
      this.logData = [];
      this.checkMicrophoneStatus = 0;
      this.db = 0;
      this.startTest();
    },
    goAdvice() {
      this.$router.push("/advice");
    },
    goback() {
      this.$router.push("/userInfo");
    }
  },
  beforeDestroy() {
    this.$root.eventHub.$off("checkMicrophonePermissionSuccess");
    this.$root.eventHub.$off("checkMicrophonePermissionError");
    clearInterval(this.checkInterval);
    if(this.ifly){
      this.ifly.stop(false);
      this.ifly.removeAllListeners(IFly.WAVE);
    }
  }
};
</script>
<style  lang="less" rel="stylesheet/less" scoped>
.equipment {
  display: flex;
  flex-direction: column;
  h2 {
    font-size: 26px;
    font-weight: 600;
    color: #ffffff;
    line-height: 65px;
    height: 65px;
    padding-top: 15px;
  }
  section {
    flex: 1;
    margin-top: -120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .default {
    // padding-top: 140px;
    ul {
      padding-bottom: 63px;
      display: flex;
      justify-content: center;
      li {
        width: 350px;
        height: 187px;
        color: #6bb3c7;
        font-size: 16px;
        background: url(../../../assets/img/equipment/check.png) no-repeat;
        background-size:cover;
      }
    }
    p {
      color: #aedceb;
      font-size: 20px;
    }
    button {
      font-size: 26px;
      color: #ffffff;
      width: 230px;
      height: 70px;
      line-height: 70px;
      background: #009eed;
      border-radius: 12px;
      margin-top: 35px;
    }
    button:hover {
      background: #0095e1;
      color: #b5d1d9;
    }
  }
  .check {
    // padding-top: 70px;
    ul {
      display: flex;
      justify-content: center;
      li {
        width: 100px;
        height: 88px;
        line-height: 128px;
        text-align: center;
        color: #9CDEFF;
      }
      .notwork{
          background: url(../../../assets/img/equipment/small_wifi.png) no-repeat top center;
          background-size: 46px;
      }
      .voice{
        background: url(../../../assets/img/equipment/small_voice.png) no-repeat top center;
        background-size: 46px;
        color: #005E8D;
      }
      .microphone{
        background: url(../../../assets/img/equipment/microphone.png) no-repeat top center;
        background-size: 46px;
        color: #005E8D;
      }
      .line {
        width: 150px;
        height: 2px;
        background: #007FBF;
        font-size: 0;
        margin-top: 23px;
      }
      li.line-active {
        opacity: 0.4;
        background:#9cdeff;
      }
      li.voice-active {
        background: url(../../../assets/img/equipment/small_voice_active.png) no-repeat top center;
        background-size: 46px;
        color: #9CDEFF;
      }
      li.microphone-active{
        background: url(../../../assets/img/equipment/microphone_active.png) no-repeat top center;
        background-size: 46px;
        color: #9CDEFF;
      }
      li.check_success {
        background: url(../../../assets/img/equipment/success.png) no-repeat top center;
        background-size: 46px;
        color: #9CDEFF;
      }
      li.check_error {
        background: url(../../../assets/img/common/error.png) no-repeat top
          center;
        background-size: 46px;
        color: #9CDEFF;
      }
    }
    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 282px;
    }
    .network_content {
      padding-top: 130px;
      .progress {
        position: relative;
        width: 110px;
        height: 110px;
        border-radius: 50%;
        span {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #aedceb;
          font-size: 18px;
        }
      }
      p {
        color: #b9eafa;
        padding-top: 20px;
      }
    }
    .voice_content,.microphone_content {
      padding-top: 40px;
      .video {
        width: 204px;
        height: 136px;
        background: rgba(180, 199, 204, 1);
        border-radius: 7px;
      }
      p {
        font-size: 22px;
        color: #9cdeff;
        padding-top: 18px;
      }
    }
    .microphone_box{
      height:136px;
      min-height: 136px;
      align-items: flex-end;
      justify-content: center;
      display: flex;
      padding-bottom: 27px;
      img{
        width: 40px;
        height: 55px;
        margin-right: 26px;
      }
      .vertical_line_box{
        font-size: 0
      }
      span{
        width: 7px;
        height: 50px;
        background: #005e8e;
        border-radius: 4px;
        display: inline-block;
        margin-left: 9px;
      }
      .vertical_line_active{
        background: #f5b227;
      }
    }
    .success_content {
      padding-top: 130px;
      .success_icon {
        width: 104px;
        height: 135px;
        background: url(../../../assets/img/common/success.png) no-repeat;
        background-size: 104px;
        color: #9CDEFF;
        line-height: 240px;
      }
    }
    .btn_box {
      padding-top: 30px;
      button {
        width: 135px;
        height: 60px;
        border-radius: 13px;
        font-size: 26px;
        line-height: 0;
        &:first-child {
          border: 2px solid #17a4eb;
          color: #88D7FF;
        }
        &:first-child:hover {
          border-color: #0e99df;
          color: #52B7EB;
        }
        &:last-child {
          background: #0099e6;
          color: #ffffff;
          margin-left: 75px;
        }
        &:last-child:hover {
          background: #0095e1;
          color: #99CFEB;
        }
      }
    }
    .btn_disabled{
      opacity: .5;
      pointer-events: none;
    }
    .error_content {
      padding-top: 80px;
      h3 {
        color: #9CDEFF;
        font-size: 24px;
        padding-bottom: 20px;
      }
      p {
        font-size: 20px;
        color: #9CDEFF;
        padding-top: 15px;
        opacity: 0.8;
        text-align: left;
      }
      .btn_box button {
        width: 230px;
      }
    }
  }
  @media screen and(max-height:670px) {
    section {
      margin-top: -40px;
    }
  }
  @media screen and(max-height:770px) {
    section {
      margin-top: -40px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/bussiness/checkEquipment/equipment.vue